import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { useHistory, useParams } from "react-router";
import {
  Box,
  Container,
  Grid,
  TextField,
  Button,
  FormGroup,
  FormControlLabel,
  Checkbox,
  FormControl,
  Input,
  InputLabel,
  Select,
  ListItemText,
  MenuItem,
} from "@material-ui/core";
import { Autocomplete } from "@mui/material";
import { Refresh } from "@material-ui/icons";
import { userAPI } from "./../services/UserService";
import { workAPI } from "./../services/WorkService";
import { setpriceAPI } from "../services/SetPriceService";
import { Formik, Form } from "formik";
import * as Yup from "yup";

const Setting_Edit_User = () => {
  let history = useHistory();
  const { _id } = useParams();
  const [data, setData] = useState(null);
  const [AllUser, setAllUser] = useState([]);
  const [BuyerUser, setBuyerUser] = useState([]);
  const [TypeUser, setTypeUser] = useState([]);
  const [category, setCategory] = useState([]);
  const [set_price_category, set_set_price_category] = useState([]);
  const FormSchema = Yup.object().shape({
    fullname: Yup.string().trim().required("*ชื่อห้ามว่าง"),
    PositionName: Yup.string().trim().required("*ชื่อตำแหน่งห้ามว่าง"),
  });
  useEffect(() => {
    userAPI
      .getUserByID(_id)
      .then((res) => {
        if (res.status == 200) {
          setData(res.message);
          if (res.userretail && Array.isArray(res.userretail)) {
            setAllUser(res.userretail);
          }
          if (
            res.message.set_price_cate &&
            Array.isArray(res.message.set_price_cate)
          ) {
            set_set_price_category(res.message.set_price_cate);
          }
          if (res.message.role == "Buyer") {
            setBuyerUser(res.message.buyerunder);
          }
          if (!!res.message.type?.length) {
            setTypeUser(res.message.type);
          }
          document.title = `Com7 Merchandise - ${res.message.fullname}`;
        } else {
          Swal.fire({
            icon: "error",
            confirmButtonColor: "#f27474",
            html: `<span class="colorWhite">${res.message}</span>`,
            backdrop: "transparent",
            background: "rgba(0,0,0,.75)",
            customClass: {
              icon: "switch",
            },
            width: "28rem",
            timer: 5000,
          }).then(() => {
            history.push("/settings/user");
          });
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          confirmButtonColor: "#f27474",
          html: `<span class="colorWhite">${error.message}</span>`,
          backdrop: "transparent",
          background: "rgba(0,0,0,.75)",
          customClass: {
            icon: "switch",
          },
          width: "28rem",
          timer: 5000,
        }).then(() => {
          history.push("/settings/user");
        });
      });
    return () => {
      setBuyerUser([]);
      setAllUser([]);
    };
  }, [_id]);

  useEffect(() => {
    setpriceAPI
      .getAllCategory()
      .then((res) => {
        if (res.status == 200) {
          if (res.message && Array.isArray(res.message)) {
            setCategory(res.message);
          }
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          confirmButtonColor: "#f27474",
          html: `<span class="colorWhite">${error.message}</span>`,
          backdrop: "transparent",
          background: "rgba(0,0,0,.75)",
          customClass: {
            icon: "switch",
          },
          width: "28rem",
          timer: 5000,
        });
      });
    return () => {
      setCategory([]);
    };
  }, []);

  const changeFullname = (name) => {
    if (Array.isArray(name)) {
      let findFullname = name.map((res) => {
        const fucking = AllUser.find((rez) => rez.username == res);
        return fucking ? fucking.fullname : res;
      });

      return findFullname;
    } else return name;
  };

  const addUnderBuyer = (e) => {
    let username = e.target.value;
    setBuyerUser(username);
  };

  const addCategory = (e) => {
    let categoryz = e.target.value;
    set_set_price_category(categoryz);
  };

   const [type, setType] = useState([]);
  
    useEffect(() => {
      const token = localStorage.getItem("Token");
      workAPI
        .GetType(token)
        .then((res) => {
          if (res.status == 200) {
            if (Array.isArray(res.message)) {
              setType(res.message);
            }
          } else throw new Error(String(res.message));
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            confirmButtonColor: "#f27474",
            html: `<span class="colorWhite">${error.message}</span>`,
            backdrop: "transparent",
            background: "rgba(0,0,0,.75)",
            customClass: {
              icon: "switch",
            },
            width: "28rem",
            timer: 10000,
          });
        });
    }, []);

  return (
    data && (
      <Formik
        validationSchema={FormSchema}
        initialValues={{ ...data }}
        enableReinitialize
        onSubmit={async (values, { setSubmitting }) => {
          try {
            if (!values.role)
              throw { message: "Role is not null. หรือก็คือห้ามว่าง" };
            Swal.fire({
              title: "คุณแน่ใจ ?",
              text: "คุณยืนยันที่จะแก้ไข User?",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#56A834",
              cancelButtonColor: "#d33",
              confirmButtonText: "แน่ใจ",
              cancelButtonText: "ยังก่อน",
            }).then((result) => {
              try {
                if (result.isConfirmed) {
                  setSubmitting(true);
                  let form = new FormData();
                  if (
                    values.Email &&
                    !String(values.Email)
                      .toLowerCase()
                      .match(
                        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                      )
                  )
                    throw { message: "รูปแบบ Email ไม่ถูกต้อง" };
                  if (values.Email) {
                    form.append("Email", values.Email);
                  }
                  form.append("_id", values._id);
                  form.append("role", values.role);
                  form.append("fullname", values.fullname);
                  form.append("PositionName", values.PositionName);
                  form.append("nickname", values.nickname || "");
                  form.append("table", values.table || "");
                  form.append("view_work", values.view_work);
                  form.append("add_work", values.add_work);
                  form.append("get_work", values.get_work);
                  form.append("view_report", values.view_report);
                  form.append(
                    "view_promotion",
                    values.username == "16282" ? true : values.view_promotion
                  );
                  if (values.Email) {
                    const checkEmail = String(values.Email)
                      .toLowerCase()
                      .match(
                        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                      );
                    if (!checkEmail)
                      throw { message: "รูปแบบ Email ไม่ถูกต้อง" };
                    form.append("Email", values.Email);
                  }
                  form.append("manage_user", values.manage_user);
                  form.append("manage_type", values.manage_type);
                  form.append("manage_template", values.manage_template);
                  form.append("manage_product", values.manage_product);
                  form.append("view_set_price", values.view_set_price || false);
                  form.append("view_min_day", values.view_min_day || false);
                  form.append(
                    "excel_set_price",
                    values.excel_set_price || false
                  );
                  form.append(
                    "manage_group_bu",
                    values.manage_group_bu || false
                  );
                  form.append("status", values.status ? "Active" : "Disable");
                  form.append(
                    "set_price_category",
                    JSON.stringify(set_price_category)
                  );
                  form.append("type", JSON.stringify(TypeUser));
                  if (
                    values.role == "Buyer" &&
                    Array.isArray(BuyerUser) &&
                    BuyerUser.length > 0
                  ) {
                    BuyerUser.map((res, i) => {
                      form.append(`buyerunder${i}`, res);
                    });
                  }
                  userAPI
                    .editUserDetail(form)
                    .then((res) => {
                      if (res.status == 200) {
                        Swal.fire({
                          icon: "success",
                          confirmButtonColor: "#6ab23a",
                          html: `<span class="colorWhite">แก้ไข ${values.fullname} เรียบร้อยแล้ว</span>`,
                          backdrop: "transparent",
                          background: "rgba(0,0,0,.75)",
                          customClass: {
                            icon: "switchZ",
                          },
                          width: "28rem",
                          timer: 3000,
                        }).then((res) => {
                          history.push("/settings/user");
                        });
                      } else {
                        setSubmitting(false);
                        Swal.fire({
                          icon: "error",
                          confirmButtonColor: "#f27474",
                          html: `<span class="colorWhite">${res.message}</span>`,
                          backdrop: "transparent",
                          background: "rgba(0,0,0,.75)",
                          customClass: {
                            icon: "switch",
                          },
                          width: "28rem",
                          timer: 3000,
                        });
                      }
                    })
                    .catch((error) => {
                      setSubmitting(false);
                      Swal.fire({
                        icon: "error",
                        confirmButtonColor: "#f27474",
                        html: `<span class="colorWhite">${error.message}</span>`,
                        backdrop: "transparent",
                        background: "rgba(0,0,0,.75)",
                        customClass: {
                          icon: "switch",
                        },
                        width: "28rem",
                        timer: 3000,
                      });
                    });
                }
              } catch (error) {
                setSubmitting(false);
                Swal.fire({
                  icon: "error",
                  confirmButtonColor: "#f27474",
                  html: `<span class="colorWhite">${error.message}</span>`,
                  backdrop: "transparent",
                  background: "rgba(0,0,0,.75)",
                  customClass: {
                    icon: "switch",
                  },
                  width: "28rem",
                  timer: 3000,
                });
              }
            });
          } catch (error) {
            setSubmitting(false);
            Swal.fire({
              icon: "error",
              confirmButtonColor: "#f27474",
              html: `<span class="colorWhite">${error.message}</span>`,
              backdrop: "transparent",
              background: "rgba(0,0,0,.75)",
              customClass: {
                icon: "switch",
              },
              width: "28rem",
              timer: 3000,
            });
          }
        }}
      >
        {({
          values,
          handleChange,
          setFieldValue,
          isSubmitting,
          touched,
          errors,
          resetForm,
        }) => (
          <Form>
            <Container
              style={{
                padding: "20px",
                backgroundColor: "#ffffffbd",
                borderRadius: "10px",
              }}
            >
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <h3>
                    <strong>
                      แก้ไขข้อมูล User{" "}
                      <Refresh
                        fontSize="small"
                        style={{ cursor: "pointer" }}
                        onClick={() => resetForm({ ...values, ...data })}
                      />
                    </strong>
                  </h3>
                </Grid>
              </Grid>
              <Container style={{ paddingTop: "1rem" }}>
                <div className="row">
                  <div className="pt-5 col-lg-12">
                    <div className="row">
                      <div className="mt-4 col-lg-12">
                        <TextField
                          name="fullname"
                          onChange={handleChange}
                          style={{ width: "100%" }}
                          value={values.fullname}
                          label="ชื่อ นามสกุล..."
                        />
                        {errors.fullname && touched.fullname ? (
                          <div style={{ color: "#FF3333" }}>
                            {errors.fullname}
                          </div>
                        ) : null}
                      </div>
                      <div className="mt-4 col-lg-12">
                        <TextField
                          name="nickname"
                          onChange={handleChange}
                          style={{ width: "100%" }}
                          value={values.nickname}
                          label="ชื่อเล่น..."
                        />
                        {errors.nickname && touched.nickname ? (
                          <div style={{ color: "#FF3333" }}>
                            {errors.nickname}
                          </div>
                        ) : null}
                      </div>
                      <div className="mt-4 col-lg-12">
                        <TextField
                          name="table"
                          onChange={handleChange}
                          style={{ width: "100%" }}
                          value={values.table}
                          label="เบอร์โต๊ะ..."
                        />
                        {errors.table && touched.table ? (
                          <div style={{ color: "#FF3333" }}>{errors.table}</div>
                        ) : null}
                      </div>
                      <div className="mt-4 col-lg-12">
                        <TextField
                          name="Email"
                          onChange={handleChange}
                          style={{ width: "100%" }}
                          value={values.Email}
                          label="Email..."
                          type="email"
                        />
                        {errors.Email && touched.Email ? (
                          <div style={{ color: "#FF3333" }}>{errors.Email}</div>
                        ) : null}
                      </div>
                      <div className="mt-4 col-lg-12">
                        <TextField
                          name="PositionName"
                          onChange={handleChange}
                          style={{ width: "100%" }}
                          value={values.PositionName}
                          label="ชื่อตำแหน่ง..."
                        />
                        {errors.PositionName && touched.PositionName ? (
                          <div style={{ color: "#FF3333" }}>
                            {errors.PositionName}
                          </div>
                        ) : null}
                      </div>
                      {!!values.view_work && (
                        <div className="mt-4 col-12">
                          <label>
                            <strong>User Role</strong>
                          </label>
                          <Autocomplete
                            name="role"
                            options={["Retail", "Support", "Buyer", "Admin"]}
                            onChange={(event, newValue) => {
                              setFieldValue("role", newValue);
                            }}
                            value={values.role}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="User Role Select..."
                                name="role"
                                variant="standard"
                                value={values?.role || ""}
                              />
                            )}
                          />
                        </div>
                      )}
                      {values.role == "Buyer" && (
                        <div className="mt-4 col-12">
                          <InputLabel>
                            <strong>Retail Merchandiser</strong>
                          </InputLabel>
                          <FormControl style={{ width: "100%" }}>
                            <Select
                              multiple
                              value={BuyerUser}
                              onChange={addUnderBuyer}
                              input={<Input />}
                              renderValue={(selected) =>
                                changeFullname(selected).join(", ")
                              }
                            >
                              {AllUser.map((res) => (
                                <MenuItem
                                  key={res.username}
                                  value={res.username}
                                >
                                  <Checkbox
                                    checked={
                                      BuyerUser.find(
                                        (rez) => rez == res.username
                                      )
                                        ? true
                                        : false
                                    }
                                  />
                                  <ListItemText primary={res.fullname} />
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </div>
                      )}
                      <div className="mt-4 col-12">
                        <div className="mt-4 col-12">
                          <label>
                            <strong>สถานะการใช้งาน</strong>
                          </label>
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={values.status}
                                  onClick={() => setFieldValue("status", true)}
                                />
                              }
                              label="Active"
                            />
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={!values.status}
                                  onClick={() => setFieldValue("status", false)}
                                />
                              }
                              label="Disable"
                            />
                          </FormGroup>
                        </div>
                      </div>
                      <Box display={"flex"}>
                        <div className="mt-4 col-4">
                          <div className="mt-4 col-12">
                            <label>
                              <strong>ดูงาน</strong>
                            </label>
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={!!values.view_work}
                                    onClick={() =>
                                      setFieldValue("view_work", true)
                                    }
                                  />
                                }
                                label="ทำได้"
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={!values.view_work}
                                    onClick={() =>
                                      setFieldValue("view_work", false)
                                    }
                                  />
                                }
                                label="ทำไม่ได้"
                              />
                            </FormGroup>
                          </div>
                        </div>
                        <div className="mt-4 col-4">
                          <div className="mt-4 col-12">
                            <label>
                              <strong>สร้างงาน</strong>
                            </label>
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={!!values.add_work}
                                    onClick={() =>
                                      setFieldValue("add_work", true)
                                    }
                                  />
                                }
                                label="ทำได้"
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={!values.add_work}
                                    onClick={() =>
                                      setFieldValue("add_work", false)
                                    }
                                  />
                                }
                                label="ทำไม่ได้"
                              />
                            </FormGroup>
                          </div>
                        </div>
                        <div className="mt-4 col-4">
                          <div className="mt-4 col-12">
                            <label>
                              <strong>รับงาน</strong>
                            </label>
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={!!values.get_work}
                                    onClick={() =>
                                      setFieldValue("get_work", true)
                                    }
                                  />
                                }
                                label="ทำได้"
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={!values.get_work}
                                    onClick={() =>
                                      setFieldValue("get_work", false)
                                    }
                                  />
                                }
                                label="ทำไม่ได้"
                              />
                            </FormGroup>
                          </div>
                        </div>
                      </Box>
                      <Box display={"flex"}>
                        <div className="mt-4 col-4">
                          <div className="mt-4 col-12">
                            <label>
                              <strong>จัดการประเภทงาน</strong>
                            </label>
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={!!values.manage_type}
                                    onClick={() =>
                                      setFieldValue("manage_type", true)
                                    }
                                  />
                                }
                                label="ทำได้"
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={!values.manage_type}
                                    onClick={() =>
                                      setFieldValue("manage_type", false)
                                    }
                                  />
                                }
                                label="ทำไม่ได้"
                              />
                            </FormGroup>
                          </div>
                        </div>
                        <div className="mt-4 col-4">
                          <div className="mt-4 col-12">
                            <label>
                              <strong>จัดการไฟล์ Template</strong>
                            </label>
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={!!values.manage_template}
                                    onClick={() =>
                                      setFieldValue("manage_template", true)
                                    }
                                  />
                                }
                                label="ทำได้"
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={!values.manage_template}
                                    onClick={() =>
                                      setFieldValue("manage_template", false)
                                    }
                                  />
                                }
                                label="ทำไม่ได้"
                              />
                            </FormGroup>
                          </div>
                        </div>
                        <div className="mt-4 col-4">
                          <div className="mt-4 col-12">
                            <label>
                              <strong>จัดการข้อมูล User</strong>
                            </label>
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={!!values.manage_user}
                                    onClick={() =>
                                      setFieldValue("manage_user", true)
                                    }
                                  />
                                }
                                label="ทำได้"
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={!values.manage_user}
                                    onClick={() =>
                                      setFieldValue("manage_user", false)
                                    }
                                  />
                                }
                                label="ทำไม่ได้"
                              />
                            </FormGroup>
                          </div>
                        </div>
                      </Box>
                      <Box display={"flex"}>
                        <div className="mt-4 col-4">
                          <div className="mt-4 col-12">
                            <label>
                              <strong>จัดการข้อมูล Product</strong>
                            </label>
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={!!values.manage_product}
                                    onClick={() =>
                                      setFieldValue("manage_product", true)
                                    }
                                  />
                                }
                                label="ทำได้"
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={!values.manage_product}
                                    onClick={() =>
                                      setFieldValue("manage_product", false)
                                    }
                                  />
                                }
                                label="ทำไม่ได้"
                              />
                            </FormGroup>
                          </div>
                        </div>
                        <div className="mt-4 col-4">
                          <div className="mt-4 col-12">
                            <label>
                              <strong>ดู Report ส่งงาน</strong>
                            </label>
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={!!values.view_report}
                                    onClick={() =>
                                      setFieldValue("view_report", true)
                                    }
                                  />
                                }
                                label="ทำได้"
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={!values.view_report}
                                    onClick={() =>
                                      setFieldValue("view_report", false)
                                    }
                                  />
                                }
                                label="ทำไม่ได้"
                              />
                            </FormGroup>
                          </div>
                        </div>
                        <div className="mt-4 col-4">
                          <div className="mt-4 col-12">
                            <label>
                              <strong>ดู Promotion</strong>
                            </label>
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={!!values.view_promotion}
                                    onClick={() =>
                                      setFieldValue("view_promotion", true)
                                    }
                                  />
                                }
                                label="ทำได้"
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={!values.view_promotion}
                                    onClick={() =>
                                      setFieldValue("view_promotion", false)
                                    }
                                  />
                                }
                                label="ทำไม่ได้"
                              />
                            </FormGroup>
                          </div>
                        </div>
                      </Box>
                      <Box display={"flex"}>
                        <div className="mt-4 col-4">
                          <div className="mt-4 col-12">
                            <label>
                              <strong>ดู Set Price</strong>
                            </label>
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={!!values.view_set_price}
                                    onClick={() =>
                                      setFieldValue("view_set_price", true)
                                    }
                                  />
                                }
                                label="ทำได้"
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={!values.view_set_price}
                                    onClick={() =>
                                      setFieldValue("view_set_price", false)
                                    }
                                  />
                                }
                                label="ทำไม่ได้"
                              />
                            </FormGroup>
                          </div>
                        </div>
                        <div className="mt-4 col-4">
                          <div className="mt-4 col-12">
                            <label>
                              <strong>Excel Set Price</strong>
                            </label>
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={!!values.excel_set_price}
                                    onClick={() =>
                                      setFieldValue("excel_set_price", true)
                                    }
                                  />
                                }
                                label="ทำได้"
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={!values.excel_set_price}
                                    onClick={() =>
                                      setFieldValue("excel_set_price", false)
                                    }
                                  />
                                }
                                label="ทำไม่ได้"
                              />
                            </FormGroup>
                          </div>
                        </div>
                        <div className="mt-4 col-4">
                          <div className="mt-4 col-12">
                            <label>
                              <strong>จัดการข้อมูล Group Bu (Set Price)</strong>
                            </label>
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={!!values.manage_group_bu}
                                    onClick={() =>
                                      setFieldValue("manage_group_bu", true)
                                    }
                                  />
                                }
                                label="ทำได้"
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={!values.manage_group_bu}
                                    onClick={() =>
                                      setFieldValue("manage_group_bu", false)
                                    }
                                  />
                                }
                                label="ทำไม่ได้"
                              />
                            </FormGroup>
                          </div>
                        </div>
                      </Box>
                      <Box display={"flex"}>
                        <div className="mt-4 col-4">
                          <div className="mt-4 col-12">
                            <label>
                              <strong>ดู Min/Day</strong>
                            </label>
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={!!values.view_min_day}
                                    onClick={() =>
                                      setFieldValue("view_min_day", true)
                                    }
                                  />
                                }
                                label="ทำได้"
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={!values.view_min_day}
                                    onClick={() =>
                                      setFieldValue("view_min_day", false)
                                    }
                                  />
                                }
                                label="ทำไม่ได้"
                              />
                            </FormGroup>
                          </div>
                        </div>
                      </Box>
                      <div className="mt-4 col-4">
                        <div className="mt-4 col-12">
                          <label>
                            <strong>
                              Type Create Work *ถ้าไม่เลือกจะเห็นทั้งหมด
                            </strong>
                          </label>
                        </div>
                      </div>

                      <div className="mt-4 col-12">
                        <FormControl style={{ width: "100%" }}>
                          <Select
                            multiple
                            value={TypeUser}
                            onChange={(e) => setTypeUser(e.target.value)}
                            input={<Input />}
                            renderValue={(selected) =>
                              changeFullname(selected).join(", ")
                            }
                          >
                            {type.map((res) => (
                              <MenuItem
                                key={`${res.type_name}-key-type_`}
                                value={res.type_name}
                              >
                                <Checkbox
                                  checked={
                                    TypeUser.find((rez) => rez == res.type_name)
                                      ? true
                                      : false
                                  }
                                />
                                <ListItemText primary={res.type_name} />
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </div>

                      {!!values.view_set_price && (
                        <div className="mt-4 col-4">
                          <div className="mt-4 col-12">
                            <label>
                              <strong>
                                Category Set Price *ถ้าไม่เลือกจะเห็นทั้งหมด
                              </strong>
                            </label>
                          </div>
                        </div>
                      )}
                      {!!values.view_set_price && (
                        <div className="mt-4 col-12">
                          <FormControl style={{ width: "100%" }}>
                            <Select
                              multiple
                              value={set_price_category}
                              onChange={addCategory}
                              input={<Input />}
                              renderValue={(selected) =>
                                changeFullname(selected).join(", ")
                              }
                            >
                              {category.map((res) => (
                                <MenuItem
                                  key={`${res}-key-category`}
                                  value={res}
                                >
                                  <Checkbox
                                    checked={
                                      set_price_category.find(
                                        (rez) => rez == res
                                      )
                                        ? true
                                        : false
                                    }
                                  />
                                  <ListItemText primary={res} />
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </div>
                      )}
                      <div className="mt-4 col-12">
                        <Button
                          variant="contained"
                          type="submit"
                          disabled={isSubmitting}
                          style={{
                            border: "2px solid transparent",
                            backgroundColor: "#6ab23a",
                            borderRadius: "5px",
                            color: "white",
                            fontSize: "16px",
                            textDecoration: "none",
                            textTransform: "capitalize",
                          }}
                        >
                          Submit
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </Container>
            </Container>
          </Form>
        )}
      </Formik>
    )
  );
};

export default Setting_Edit_User;
